<template>
  <div class="pvd-container p-xsmall-top">
    <slot />
    <template v-if="showCustomerDisclosure">
      <ol
        v-if="listDisclosure"
        class="pvd-list-number xsmall"
      >
        <li
          v-for="listItem in orderedListDisclosure"
          :key="listItem"
          class="color-neutral"
        >
          {{ listItem }}
        </li>
      </ol>
      <p
        v-for="paragraph in orderedParagraphDisclosure"
        :key="paragraph"
        class="xsmall color-neutral"
      >
        <VueShowdown
          :extensions="[formatMarkdown]"
          :markdown="paragraph"
          tag="span"
        />
      </p>
      <pvd-expand-collapse
        v-if="additionalDisclosure"
        title="Additional Important Information"
        animate="true"
        class="xsmall m-medium-top"
      >
        <p
          v-for="paragraph in orderedAdditionalDisclosure"
          :key="paragraph"
          class="xsmall color-neutral"
        >
          <VueShowdown
            :extensions="[formatMarkdown]"
            :markdown="paragraph"
            tag="span"
          />
        </p>
      </pvd-expand-collapse>
    </template>
  </div>
</template>

<script>
import utility from '../mixins/utility';

export default {
  name: 'DisclosureComponent',
  mixins: [utility],
  props: {
    additionalDisclosure: {
      type: Object,
      default: () => {},
    },
    listDisclosure: {
      type: Object,
      default: () => {},
    },
    paragraphDisclosure: {
      type: Object,
      default: () => {},
    },
    showCustomerDisclosure: {
      type: Boolean,
      default: () => true,
    },
  },
  computed: {
    orderedAdditionalDisclosure() {
      return this.sortObjectByKey(this.additionalDisclosure);
    },
    orderedListDisclosure() {
      return this.sortObjectByKey(this.listDisclosure);
    },
    orderedParagraphDisclosure() {
      return this.sortObjectByKey(this.paragraphDisclosure);
    },
  },
};
</script>

<style scoped>

</style>
